import React from 'react';
import { Modal } from 'antd';
import AIWorkspace from './AIWorkspace';
import { loadScriptScenes } from './loadScriptScenes';
import './MediaToolsModal.css';

// Same tool implementations and owner-only saved records in both entry points.
export default function MediaToolsModal({ script, mode, onClose, beforeGenerate, onCharacters }) {
  const toolIds = mode === 'storyboard' ? ['storyboard'] : ['video', 'premium', 'scene-studio'];
  return <Modal open width={1100} footer={null} className="media-tools-modal" maskClosable={false}
    title={`${mode === 'storyboard' ? 'Storyboard' : 'AI Video'} · ${script.title || 'Untitled Script'}`}
    onCancel={onClose} destroyOnClose>
    <AIWorkspace fixedScript={script} toolIds={toolIds} initialTool={toolIds[0]}
      beforeGenerate={beforeGenerate || (() => loadScriptScenes(script._id))} onCharacters={onCharacters} />
  </Modal>;
}